import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'
import { getDisplayBusinessName } from 'shared/js/locationUtils'

import CheckoutSection from 'public/components/default_template/online_ordering/checkout/CheckoutSection'

import { useCart } from 'public/components/online_ordering/CartContext'
import { formatLocationAddress } from 'public/components/online_ordering/addressUtils'
import { useDeleteShippingRate } from './hooks/useDeleteShippingRate'
import { PickupFulfillmentTime } from './PickupFulfillmentTime'
import { LocationMap } from 'public/components/default_template/schedule_map'
import { t } from 'src/translations'
import classnames from 'classnames'
import { useCustomer } from 'src/public/components/online_ordering/CustomerContextCommon'

export const PickupSection = () => {
  const { ooRestaurant } = useRestaurant()
  const { cart } = useCart()
  const { unregister } = useFormContext()
  useDeleteShippingRate()

  // WOO-5034: Unregister address field when switching to pickup
  // DeliverySection and ShippingSection register this as required
  useEffect(() => {
    unregister('address')
  }, [unregister])

  if (!cart?.restaurant?.location || !ooRestaurant || !cart?.order) {
    return null
  }

  return (
    <CheckoutSection>
      <div className='pickup-section'>
        <span className='header'>
          {t('pickup-fulfillment-time.pickup-details')}
        </span>
        <LocationMap
          name={cart.restaurant.name}
          address1={cart.restaurant.location.address1}
          address2={cart.restaurant.location.address2}
          city={cart.restaurant.location.city}
          state={cart.restaurant.location.state}
          zipcode={cart.restaurant.location.zip}
          alwaysShowMap={true}
          wrapperClassName='map mapFrame'
          trackerContext='pickup'
        />
      </div>
      <PickupFulfillmentTime className='fulfillment-time-row' />
      <TakeoutDetails />
    </CheckoutSection>
  )
}

/** Renders map and curbside pickup options details for takeout orders */
export const TakeoutDetails = () => {
  const { cart } = useCart()
  const { ooRestaurant, selectedLocation } = useRestaurant()
  const { customer } = useCustomer()

  if (!cart?.restaurant?.location || !ooRestaurant || !cart?.order) {
    return null
  }
  return (
    <div className='takeoutDetails'>
      {/* Restaurant Information Section */}
      <div
        className={classnames('fulfillment-list-item', {
          authenticated: !!customer
        })}
      >
        <div className='restaurant-info'>
          <div className='restaurant-name'>
            {getDisplayBusinessName(
              ooRestaurant.whiteLabelName || cart.restaurant.name,
              selectedLocation?.name
            )}
          </div>
          <div className='restaurant-address'>
            {formatLocationAddress(cart.restaurant.location)}
          </div>
        </div>
        {/* Edit button placeholder - will be implemented later for multi-location
        <div className='edit-button' style={{ opacity: 0.5 }}>
          <span>Edit</span>
        </div>*/}
      </div>
    </div>
  )
}

export const LocationSection = () => {
  const { cart } = useCart()
  const { ooRestaurant, selectedLocation } = useRestaurant()

  if (!cart?.restaurant?.location || !ooRestaurant || !cart?.order) {
    return null
  }

  return (
    <CheckoutSection className='noSectionDivider'>
      <h2 className='subHeader rxName'>
        {getDisplayBusinessName(
          ooRestaurant.whiteLabelName || cart.restaurant.name,
          selectedLocation?.name
        )}
      </h2>
      <div className='locationSubHeader'>
        {formatLocationAddress(cart.restaurant.location)}
      </div>
    </CheckoutSection>
  )
}
